import { render } from "./GameView.vue?vue&type=template&id=bd266a58&scoped=true"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=bd266a58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\carlc\\portfolio\\portfolio-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd266a58"]])

export default __exports__